const visit = require('unist-util-visit');
const definitions = require('mdast-util-definitions');
const spaceSeparated = require('space-separated-tokens').parse;
const absolute = require('is-absolute-url');
const extend = require('extend');
const url = require('url');

const defaultTarget = '_blank';
const defaultRel = ['nofollow', 'noopener'];
const defaultProtocols = ['http', 'https'];

function isVoteAmericaURL(urlStr) {
  return (
    urlStr.startsWith('https://www.voteamerica.org') ||
    urlStr.startsWith('https://voteamerica.org') ||
    urlStr.startsWith('http://www.voteamerica.org') ||
    urlStr.startsWith('http://voteamerica.org')
  );
}

function convertToRelativeURL(urlStr) {
  const urlParsed = url.parse(urlStr);
  return `${urlParsed.path}${urlParsed.hash || ''}`;
}

// This function, save for the VOTEAMERICA CHANGES noted below, is taken
// directly from remark-external-links under the MIT license:
// https://github.com/remarkjs/remark-external-links/blob/main/license
function externalLinks(options) {
  const settings = options || {};
  const { target } = settings;
  let { rel, content } = settings;
  const protocols = settings.protocols || defaultProtocols;
  const contentProperties = settings.contentProperties || {};

  if (typeof rel === 'string') {
    rel = spaceSeparated(rel);
  }

  if (content && typeof content === 'object' && !('length' in content)) {
    content = [content];
  }

  function transform(tree) {
    const definition = definitions(tree);

    function visitor(node) {
      const ctx = node.type === 'link' ? node : definition(node.identifier);
      let data;
      let props;

      if (!ctx) return;

      const protocol = ctx.url.slice(0, ctx.url.indexOf(':'));

      // BEGIN VOTEAMERICA CHANGES
      if (isVoteAmericaURL(ctx.url)) {
        ctx.url = convertToRelativeURL(ctx.url);
      }
      // END VOTEAMERICA CHANGES
      else if (absolute(ctx.url) && protocols.indexOf(protocol) !== -1) {
        // eslint-disable-next-line no-param-reassign
        data = node.data || (node.data = {});
        props = data.hProperties || (data.hProperties = {});

        if (target !== false) {
          props.target = target || defaultTarget;
        }

        if (rel !== false) {
          props.rel = (rel || defaultRel).concat();
        }

        if (content) {
          // `fragment` is not a known mdast node, but unknown nodes with
          // children are handled as elements by `mdast-util-to-hast`:
          // See: <https://github.com/syntax-tree/mdast-util-to-hast#notes>.
          node.children.push({
            type: 'fragment',
            children: [],
            data: {
              hName: 'span',
              hProperties: extend(true, contentProperties),
              hChildren: extend(true, content),
            },
          });
        }
      }
    }

    visit(tree, ['link', 'linkReference'], visitor);
  }

  return transform;
}

// Transformer, conforming to the gatsby remark plugin API
module.exports = (
  { markdownAST },
  options = {
    target: '_blank',
    rel: ['nofollow', 'noopener'],
  }
) => {
  const transformer = externalLinks(options);

  transformer(markdownAST, options);
};

// Alternative export -- this conforms Remark's own plugin API
module.exports.remarkExternalLinks = externalLinks;
